import { observer } from 'mobx-react-lite';
import React from 'react';
import { MomentModel } from '../../entities/moment';
import { ArrowRightSVGIcon } from '../svg';

type Props = {
  model: MomentModel;
  showEndTime?: boolean;
};

export const PlayerMomentTime = observer(({
  model,
  showEndTime = true,
}: Props) => {

  return (
    <div className="user-player-moment-time">
      <span className="time text">
        <span className="text">{model?.startTimeLabel || '0:00'}</span>
        {showEndTime &&
          <>
            <span className="icon"><ArrowRightSVGIcon /></span>
            <span className="text">{model?.endTimeLabel || '0:00'}</span>
          </>}
      </span>
    </div>
  );
});
